<template>
    <div>
        <div class="module-not-available-container "></div>

        <div class="info-box">
            <i :class="icon" class="fal fa-5x"></i>

            <h3>{{ $t(title) }}</h3>

            <p>{{ $t(text) }}</p>
        </div>

    </div>
</template>

<script>
    export default {

        data() {
            return {
                icon: this.$root.$data.icon,
                title: this.$root.$data.title,
                text: this.$root.$data.text


            };
        }

    }
</script>

<style scoped>

    .module-not-available-container {
    }

    .info-box {
        width: 75%;
        margin: 35px auto;
        background-color: #f6f6f6;

        padding: 45px;
        min-height: 300px;
        text-align: center;
    }

    h3 {
        margin-top: 50px;
    }

</style>